import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/initiative/importer/initiativeImporterActions';

export default importerReducers(actions);
